/// <amd-module name="Test/TestPlansHubRefresh/TestSuiteImportPanel/Redux/TestSuiteImportPanelContracts" />
import { ITestHubRefreshAwareState } from "Test/TestPlansHubRefresh/TestHub/Redux/TestHubRefresh/TestHubRefreshContracts";
import { TeamProjectReference } from "Tfs/Platform/Contracts/Core";
import { TestPlan, TestSuite } from "TestPlanCommon/Contracts/TestPlan";

export interface ITestSuiteImportPanelAwareState extends ITestHubRefreshAwareState {
    testSuiteImportPanelState: ITestSuiteImportPanelState;
}

export interface ITestSuiteImportPanelState {
    opId: number;
    newSuiteId: number;
    cloneInProgress: boolean;
    modulesLoaded: boolean;
    mandatoryFieldUpdated: boolean;
    projectList: TeamProjectReference[];
    testPlanList: TestPlan[];
    testPlanListProject: string;
    suiteList: TestSuite[];
    testPlanSelectionErrorMessage: string;
    testSuiteSelectionErrorMessage: string;
    disableTestSuiteDropdown: boolean;
}